import { fromDateString, toUTCMidnight } from '@/lib/utils/common/dateFormats';

const FOURTEEN_DAYS = 14;

const formatUTCDateAsISOString = (date: Date): string => {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const collectDescendantIds = (
  rootId: number,
  childrenByParentId: Map<number, number[]>,
  out: number[],
) => {
  const children = childrenByParentId.get(rootId);
  if (!children) return;
  for (const childId of children) {
    out.push(childId);
    collectDescendantIds(childId, childrenByParentId, out);
  }
};

export const getTimelineStartDate = (timelineStartDate: string): string => {
  const date = fromDateString(timelineStartDate);
  if (!date) return timelineStartDate;
  const twoWeeksEarlier = toUTCMidnight(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate() - FOURTEEN_DAYS,
  );
  return formatUTCDateAsISOString(twoWeeksEarlier);
};

export const getTimelineEndDate = (timelineEndDate: string): string => {
  const date = fromDateString(timelineEndDate);
  if (!date) return timelineEndDate;
  const oneMonthLater = toUTCMidnight(date.getUTCFullYear(), date.getUTCMonth() + 2, 0);
  return formatUTCDateAsISOString(oneMonthLater);
};
